import { type FC, type ReactNode } from 'react';
import OrganizationContext from './OrganizationContext';

interface OrganizationProviderProps {
  children?: ReactNode;
  organizationId?: OrgId;
}

const OrganizationProvider: FC<OrganizationProviderProps> = ({ children, organizationId }) => (
  <OrganizationContext.Provider value={organizationId}>{children}</OrganizationContext.Provider>
);

export default OrganizationProvider;
